import React from 'react';
import './GlassBox.css';

const GlassBox = ({ onLoginClick, onSignupClick }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onLoginClick();
    }
  };

  return (
    <div className="glass-box" role="main" aria-label="Main content">
      <div className="glass-content">
        {/* Main Content Area */}
        <div className="glass-main-content">
          {/* <div className="content-header">
            <span className="sub-heading">RDV Systems presents</span>
          </div> */}
          
          <h1 className="glass-title">
           Infrastructure Safety & Visualization <strong>Solutions</strong>
          </h1>
          
          <p className="content-description">
          Advanced road safety audit and analysis with cutting-edge 3D AI technology. <strong>Monitor</strong>, <strong>analyze</strong>, <strong>detect</strong>, and <strong>report</strong> on critical elements with greater accuracy and speed.
          </p>
          
          <div className="cta-buttons" role="group" aria-label="Action buttons">
            <button 
              className="primary-btn" 
              onClick={onLoginClick}
              onKeyDown={handleKeyDown}
              aria-label="Login to your account to access the analysis platform"
            >
              Account Login
            </button>
            {/* Invited people create their account with their invitation code (/signup). */}
            <button
              type="button"
              className="secondary-btn"
              onClick={onSignupClick}
              aria-label="Sign up with your invitation code"
            >
              Sign Up
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlassBox;
